import { apiCall } from './gqlClient';

const ATHLETENUTRITIONPLANS_QUERY = `
  query athleteNutritionPlans($athleteProfileId: String!) {
    athleteNutritionPlans(athleteProfileId: $athleteProfileId)
    {
      id
			athleteProfileId
			nutritionPlanId
			status
			enrollmentSource
			orderId
			assignedResourceId
			startDate
			targets
			targetsFollowPlan
			currentPhaseName
			note
			createdAt
			updatedAt
			providerId
			title
			description
			numberOfWeeks
			imageUrl
			coverUrl
      ...fragments
    }
  }`;

export const athleteNutritionPlansApiCall = async ({athleteProfileId}, fragments = null) => apiCall({ query: ATHLETENUTRITIONPLANS_QUERY, variables: {athleteProfileId}, fragments });

const PROVIDERATHLETENUTRITIONPLANS_QUERY = `
  query providerAthleteNutritionPlans {
    providerAthleteNutritionPlans
    {
      id
			athleteProfileId
			nutritionPlanId
			status
			enrollmentSource
			orderId
			assignedResourceId
			startDate
			targets
			targetsFollowPlan
			currentPhaseName
			note
			createdAt
			updatedAt
			providerId
			title
			description
			numberOfWeeks
			imageUrl
			coverUrl
      ...fragments
    }
  }`;

export const providerAthleteNutritionPlansApiCall = async (fragments = null) => apiCall({ query: PROVIDERATHLETENUTRITIONPLANS_QUERY, variables: {}, fragments });

const ATHLETENUTRITIONPLAN_QUERY = `
  query athleteNutritionPlan($id: String!) {
    athleteNutritionPlan(id: $id)
    {
      id
			athleteProfileId
			nutritionPlanId
			status
			enrollmentSource
			orderId
			assignedResourceId
			startDate
			targets
			targetsFollowPlan
			currentPhaseName
			note
			createdAt
			updatedAt
			providerId
			title
			description
			numberOfWeeks
			imageUrl
			coverUrl
      ...fragments
    }
  }`;

export const athleteNutritionPlanApiCall = async ({id}, fragments = null) => apiCall({ query: ATHLETENUTRITIONPLAN_QUERY, variables: {id}, fragments });

const MYATHLETENUTRITIONPLANS_QUERY = `
  query myAthleteNutritionPlans {
    myAthleteNutritionPlans
    {
      id
			athleteProfileId
			nutritionPlanId
			status
			enrollmentSource
			orderId
			assignedResourceId
			startDate
			targets
			targetsFollowPlan
			currentPhaseName
			note
			createdAt
			updatedAt
			providerId
			title
			description
			numberOfWeeks
			imageUrl
			coverUrl
      ...fragments
    }
  }`;

export const myAthleteNutritionPlansApiCall = async (fragments = null) => apiCall({ query: MYATHLETENUTRITIONPLANS_QUERY, variables: {}, fragments });

const ASSIGNNUTRITIONPLANTOATHLETE_QUERY = `
  mutation assignNutritionPlanToAthlete($input: AthleteNutritionPlanInput!) {
    assignNutritionPlanToAthlete(input: $input)
    {
      id
			athleteProfileId
			nutritionPlanId
			status
			enrollmentSource
			orderId
			assignedResourceId
			startDate
			targets
			targetsFollowPlan
			currentPhaseName
			note
			createdAt
			updatedAt
			providerId
			title
			description
			numberOfWeeks
			imageUrl
			coverUrl
      ...fragments
    }
  }`;

export const assignNutritionPlanToAthleteApiCall = async ({input}, fragments = null) => apiCall({ query: ASSIGNNUTRITIONPLANTOATHLETE_QUERY, variables: {input}, fragments });

const UPDATEATHLETENUTRITIONPLAN_QUERY = `
  mutation updateAthleteNutritionPlan($id: String!, $input: AthleteNutritionPlanInput!) {
    updateAthleteNutritionPlan(id: $id, input: $input)
    {
      id
			athleteProfileId
			nutritionPlanId
			status
			enrollmentSource
			orderId
			assignedResourceId
			startDate
			targets
			targetsFollowPlan
			currentPhaseName
			note
			createdAt
			updatedAt
			providerId
			title
			description
			numberOfWeeks
			imageUrl
			coverUrl
      ...fragments
    }
  }`;

export const updateAthleteNutritionPlanApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATEATHLETENUTRITIONPLAN_QUERY, variables: {id, input}, fragments });

const UPDATEATHLETENUTRITIONPLANSTATUS_QUERY = `
  mutation updateAthleteNutritionPlanStatus($id: String!, $status: AthleteNutritionPlanStatus!) {
    updateAthleteNutritionPlanStatus(id: $id, status: $status)
    {
      id
			athleteProfileId
			nutritionPlanId
			status
			enrollmentSource
			orderId
			assignedResourceId
			startDate
			targets
			targetsFollowPlan
			currentPhaseName
			note
			createdAt
			updatedAt
			providerId
			title
			description
			numberOfWeeks
			imageUrl
			coverUrl
      ...fragments
    }
  }`;

export const updateAthleteNutritionPlanStatusApiCall = async ({id, status}, fragments = null) => apiCall({ query: UPDATEATHLETENUTRITIONPLANSTATUS_QUERY, variables: {id, status}, fragments });
